import React, { useState, useEffect } from 'react';
import { InformePericial, Videoperitacion, FaseInforme } from '../../types';
import { informeService } from '../../services/api';
import './EncargoForm.css';
import VideoCallComponent from './VideoCallComponent';

interface VideoperitacionUploadProps {
    informe?: InformePericial;
    onUpdate: (informe: InformePericial, targetFase?: FaseInforme) => void;
}

const VideoperitacionUpload: React.FC<VideoperitacionUploadProps> = ({ informe, onUpdate }) => {
    const [videoperitacion, setVideoperitacion] = useState<Videoperitacion | null>(null);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        if (informe) {
            prvCargarVideoperitacion();
        }
    }, [informe]);

    const prvCargarVideoperitacion = async () => {
        if (!informe) return;
        try {
            const response = await informeService.obtenerVideoperitacion(informe.id);
            setVideoperitacion(response.data);
        } catch (err: any) {
            if (err.response && err.response.status === 404) {
                setVideoperitacion(null);
            } else {
                setError('No se pudo comprobar el estado de los archivos. Revisa tu conexión.');
                console.error('Error obteniendo videoperitación:', err);
            }
        }
    };

    const prvHandleSiguienteFase = async () => {
        if (!informe) return;
        let updatedInforme = informe;
        try {
            const res = await informeService.cambiarFase(informe.id, 'subidaArchivos');
            updatedInforme = res.data;
        } catch (e) {
            console.error('Error al cambiar de fase:', e);
        }
        onUpdate(updatedInforme, 'subidaArchivos');
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ flexShrink: 0, marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 className="section-title" style={{ margin: 0 }}>Videoperitación Integrada</h3>
                {informe && (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={prvHandleSiguienteFase}
                    >
                        Siguiente Fase
                    </button>
                )}
            </div>

            <div style={{ border: '2px solid #cbd5e1', borderRadius: '8px', padding: '20px', backgroundColor: '#f8fafc' }}>
                {error && <div className="error-message mb-4">{error}</div>}

                {informe && (
                    <div className="mb-8">
                        <VideoCallComponent 
                            encargoId={informe.id} 
                            capturedImages={videoperitacion?.imagenes_urls || []}
                            onPhotoCaptured={() => prvCargarVideoperitacion()} 
                            onCallEnded={() => prvCargarVideoperitacion()}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default VideoperitacionUpload;
